// GLOBAL THEME JS

// DOM SELECTION 

//Functions Site Wide

// HEADER

// Mobile Nav toggle open
document.querySelector("#toggle").addEventListener("click", function() {
  this.classList.toggle("active");
  document.querySelector("#overlay").classList.toggle("open");
  document.body.classList.toggle("overflow-hidden");
});

// Header Mobile Menu Accordion

const mobNavAcc = document.getElementsByClassName("accordion-mobile");

for (i = 0; i < mobNavAcc.length; i++) {
  mobNavAcc[i].onclick = function() {

	if( !this.classList.contains('active') ){
    	closeAll();
    }
	
  this.classList.toggle("active");
    const panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  }
  
}
mobNavAcc[0].click();

function closeAll(){
	 for (i = 0; i < mobNavAcc.length; i++) {
    	mobNavAcc[i].classList.remove("active");
        mobNavAcc[i].nextElementSibling.style.maxHeight = null;
    }
}


// Search Function

// Search Bar Wrapper
const searchWrapper = document.querySelector('.header-search-bar--wrapper');
const searchInner = document.querySelector('.search-inner');
const searchForm = document.querySelector('.header-search-bar');

var predictiveSearchInput = document.getElementById('searchInputField');
var timer;

var offcanvasSearch = document.getElementById('searchResult');
var bsOffcanvas = document.getElementById('searchResult');

if(predictiveSearchInput != null) {
    predictiveSearchInput.addEventListener('input', function(e) {

        clearTimeout(timer);

        if(predictiveSearchInput.value) {
            timer = setTimeout(fetchPredictiveSearch, 500);
        }
        
    });
}

function fetchPredictiveSearch() {
    fetch(`/search/suggest.json?q=${predictiveSearchInput.value}&resources[type]=product`)
    .then(resp => resp.json())
    .then(data => { 
        console.log(data);

        var products = data.resources.results.products;

        document.getElementById('search_results_body').innerHTML = '';

        products.forEach(function(product, index) {
            document.getElementById('search_results_body').innerHTML += `
                <a href="${product.url}">
                    <div class="flex items-start mb-10" style="w-320">
                    <img src="${product.image}" class="w-100">
                    <div class="ml-10">
                        <p class="uppercase mt-0 mb-5">${product.title}</p>
                        <p class="m-0" style="color:#edd100;">$${product.price}</p>
                    </div>
                </div>
                </a>
            `
        });
        bsOffcanvas.classList.add("block");
    });
}

function openSearch() {
  searchWrapper.classList.toggle("shown");
  searchInner.classList.toggle("shown-2");
  searchForm.classList.remove("hidden");
}

function removeSearch() {
  searchWrapper.classList.remove("shown");
  searchInner.classList.remove("shown-2");
  searchForm.classList.toggle("hidden");
}

// Tabs

function activateTabs(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-contents");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tab-button");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

// Localization form JavaScript

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);